import { Component, EventEmitter, OnDestroy, OnInit, Output } from '@angular/core';
import { NgIf } from '@angular/common';
import { MatCardModule } from '@angular/material/card';
import { MatTableModule } from '@angular/material/table';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatBadgeModule } from '@angular/material/badge';
import { Vessel } from '../../dto/vessel';
import { VesselService } from '../../service/vessel.service';
import { StateNotifyService } from '../../../../common/state/service/state-notify.service';
import { Router } from '@angular/router';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'dpi-vessel-list',
  imports: [MatCardModule, MatTableModule, MatIconModule, MatButtonModule, MatToolbarModule, MatTooltipModule, MatBadgeModule, NgIf],
  templateUrl: './vessel-list.component.html',
  styleUrl: './vessel-list.component.scss'
})
export class VesselListComponent implements OnInit, OnDestroy {
  displayedColumns: string[] = ['name', 'description', 'cons_year', 'last_trail'];
  dataSource: Vessel[] = [];
  destroyed$ = new Subject<void>(); // notifier of component destroyed
  @Output('listSizeChanged') listSize = new EventEmitter<number>();
  isReadonly: boolean;

  constructor(private vesselService: VesselService, private notifyService: StateNotifyService, private router: Router) {
    this.isReadonly = true;
  }

  ngOnDestroy(): void {
    this.destroyed$.next();
    this.destroyed$.complete();
  }

  ngOnInit(): void {
    this.notifyService.customerSelection$
      .pipe(takeUntil(this.destroyed$))
      .subscribe(
        model => this.reload(model.id))

    this.notifyService.readonlyMode$
      .pipe(takeUntil(this.destroyed$))
      .subscribe(res => {
        this.isReadonly = res;
      });
  }

  reload(customerId: number) {
    this.vesselService.getAllVesselsOfCustomer(customerId)
      .pipe(takeUntil(this.destroyed$))
      .subscribe({
        next: res => { 
          this.dataSource = res; 
          this.notifyService.updateListAllVessels(this.dataSource); // for the list of all vessels in SideNav
          this.listSize.emit(this.dataSource.length)
        },
        error: err => { console.log(err); this.dataSource = []; }
      });
  }

  selectVessel(selected: Vessel) {
    this.notifyService.updateVesselSelection(selected);
    this.router.navigate(['vessel-hub']);
  }

  createVessel() {
    let customerModel = this.notifyService.getSelectedCustomer();
    this.vesselService.createVessel(customerModel.id)
      .pipe(takeUntil(this.destroyed$))
      .subscribe({
        next: model => {
          this.dataSource.push(model);
          this.selectVessel(model);
        },
        error: err => { console.log(err); }
      });
  }
}
